// extracted by mini-css-extract-plugin
export default {"boxContainer":"info-box_boxContainer__cmwOZ","head":"info-box_head__qvN2Q","text":"info-box_text__SHaz9"};